module.exports = __webpack_public_path__ + "img/culture.c68b9cc3.png";